import { isLoggedInSelector } from '../../user/user.selectors';
export const isFilterOpenTenantSelector = state => {
  return isLoggedInSelector(state);
};